import type {
  ReceivablePaymentMethod,
  ReceivablePaymentStatus,
  ReceivableStatus,
} from "@artisancode/api-types";

export const RECEIVABLE_STATUS_LABELS: Record<ReceivableStatus, string> = {
  open: "Belum Lunas",
  overdue: "Jatuh Tempo",
  settled: "Lunas",
};

export const VERIFICATION_STATUS_LABELS: Record<
  ReceivablePaymentStatus,
  string
> = {
  pending: "Belum Diverifikasi",
  verified: "Terverifikasi",
};

export const PAYMENT_METHOD_LABELS: Record<ReceivablePaymentMethod, string> = {
  cash: "Tunai",
  edc: "EDC",
  qris: "QRIS",
  app_qris: "App QRIS",
  bank_transfer: "Transfer",
};
